(function () {
    'ngInject';

    angular.module('app.shared.services').factory('RemoveBgService', removeBgService);

    function removeBgService(blockUI, RemoveBgAPIService, MultipleFileUploadService, $window, $mdDialog, $timeout) {
        async function applyFilter(object = null, $scope, canvas) {
            const { imageSelected } = $scope;
            const targetObject = object ? object : imageSelected;

            if (targetObject.imageFile) {
                const blockUIMessage = 'Cutting Background ✂️';
                blockUI.start(blockUIMessage);

                try {
                    const response = await RemoveBgAPIService.removeBackground(
                        $scope.apiKeys.removeBg,
                        targetObject.imageFile
                    );
                    targetObject.oldImageFile = targetObject.imageFile;
                    targetObject.imageFile = response;
                    await MultipleFileUploadService.uploadMultipleImages($scope, canvas, [response], targetObject);
                    console.log('done rendering image in placeholder, removing block UI');
                } catch (error) {
                    $window.rumReportError(error);
                    targetObject.oldImageFile = null;
                    $timeout(() => $scope.$apply());
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .parent(document.body)
                            .clickOutsideToClose(true)
                            .title('Remove.bg Error' + (error.statusText ? ': ' + error.statusText : '!'))
                            .textContent(
                                'There seems to be an error with your remove.bg account, so the background could not be removed from the image. Please visit your account on remove.bg to correct this.'
                            )
                            .ok('OK!')
                    );
                } finally {
                    $scope.$apply(() => blockUI.stop());
                }
            }
        }

        return {
            applyFilter: applyFilter
        };
    }
})();
